

define(['jquery', 'squid', 'text!./template.html', '../shipping-address/directive'], function ($, squid, template) {

    return squid.module('xo-select-shipping.update-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoUpdateShipping', function () {

        return {
            template: template,

            scope: {
                auth: '=',
                token: '=',
                doneFn: '=',
                sidebar: '='
            },
            controller: function controller($scope) {}
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-member-components/src/select-shipping/update-shipping/directive.js
 ** module id = 313
 ** module chunks = 1
 **/